import React, { JSXElementConstructor } from 'react';
import { JsxElement } from 'typescript';

export type DataType = 'date' | 'number' | 'string' | 'link' | 'custom';

export interface columnType {
	name: string;
	title: string;
	type: DataType;
	eventsHandle?: { [key: string]: (event: React.MouseEvent<HTMLElement>) => void };
	fieldId: string;
	customValueHandle?: (value: string, record: { [key: string]: string | number }) => void;
	formatDate?: string;
	/** When false, header has no sort control. Default true. */
	sortable?: boolean;
	/** When true, header and mobile row labels are visually hidden for icon/action-only columns. */
	hideHeaderLabel?: boolean;
}

export type Order = 'asc' | 'desc';
export type dataType = { [key: string]: string | number };
export interface tableProps {
	data: dataType[];
	columns: columnType[];
	defaultSortBy?: string;
	rowsClass?: string;
	tableClass?: string;
	actionsCell?: {
		condition?: { column: string; value: any; isPDF?: boolean };
		/** When set, row is included only if this returns true (preferred over condition for complex rules). */
		match?: (record: dataType) => boolean;
		element?: any;
		/** Per-row content; when set, element/onClick wrapper is not used. */
		render?: (record: any) => React.ReactNode;
		onClick?: (record: any) => void;
	}[];
	fieldId?: string;
	filterList?: filterList;
	includeSearchBox?: boolean;
	searchColumns?: string[];
	noPagination?: boolean;
	noSlice?: boolean;
	defaultOrderBy?: Order;
	hideHeader?: boolean;
	perPage?: number;
	noShrink?: boolean;
	navbarSearchMode?: boolean;
	navbarSearchWord?: string;
	handleChangeOnClose?: boolean;
  headerComponent?: any
  triggerFilteredData?:any
}

export interface tableState {
	sortBy?: string;
	orderBy: Order;
	perPage: number;
	page: number;
	total: number;
	filters: filterList;
}

export const initialTableState: tableState = {
	orderBy: 'desc',
	perPage: 10,
	page: 0,
	total: 0,
	filters: {},
};

export interface EnhancedTableProps {
	onRequestSort: (tableState: tableState, setState: any, property: string) => void;
	order: Order;
	orderBy: string;
	rowCount: number;
	headCells: columnType[];
	tableState: tableState;
	setState: any;
}

export enum FilterType {
	'unique',
	'search',
	'dateRange',
}

export interface filterData {
	column: string;
	values: string[];
}

export interface filterItem {
	type: FilterType;
	label: string;
	value?: any;
	handleChange?: any;
	primaryOption?: string;
}

export type filterList = { [key: string]: filterItem };

export interface filterProps {
	filterList?: filterList;
	data: dataType[];
	handleChange: any;
	tableState: tableState;
	includeSearchBox?: boolean;
	searchColumns?: string[];
	navbarSearchMode?: boolean;
	navbarSearchWord?: string;
	primaryOption?: string;
	handleChangeOnClose?: boolean;
  HeaderComponent?: any
}
